import { createUseStyles } from 'react-jss'
import { forPhoneOnly } from 'src/config/mediaQueries'

export default createUseStyles({
  footer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 16,
    [forPhoneOnly]: { gap: 10 },
  },
})
